import axios from "axios";
import { getToken } from "./auth.service";
import { clearAuthorizationCache } from "auth/authorization.service";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Nếu là FormData thì không đặt Content-Type để browser tự xử lý multipart/form-data
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];

      // Log để debug
      if (config.url && config.url.includes("document")) {
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // Legacy endpoints sometimes return HTTP 200 with a failed business wrapper.
    if (response.data?.success === false || response.data?.Success === false) {
      const error = new Error(response.data.message || response.data.Message || "Không thể thực hiện thao tác.");
      error.response = response;
      return Promise.reject(error);
    }
    return response;
  },
  (error) => {
    console.error("API Error Response:", error);
    // You could implement global error handling here
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access
      console.warn("Unauthorized access. Redirecting to login...");
      clearAuthorizationCache();
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
